<div class="flex flex-col h-full">
  <!-- Breadcrumb -->
  <div class="flex items-center gap-1 mb-10 text-outline label-medium" aria-label="breadcrumb">
    <a routerLink="/home" class="hover:underline cursor-pointer" (click)="onBreadcrumbHome()">
      {{ 'Home' | translate }}
    </a>
    <span class="material-icons text-outline-variant! text-lg!">chevron_right</span>
    <span>
      {{ 'Create documents' | translate }}
    </span>
    <span class="material-icons text-outline-variant! text-lg!">chevron_right</span>
    <span class="text-on-surface">
      {{ 'Upload a file' | translate }}
    </span>
  </div>

  <!-- Hidden native file input used by the upload area -->
  <input
    #fileInput
    type="file"
    class="hidden"
    [accept]="acceptAttr"
    (change)="onFileInputChange($event)" />

  <!-- Upload Content Area -->
  <div class="flex-1 flex items-center justify-center">

    <!-- State 1: Idle (Empty Area) -->
    <div
      *ngIf="state === 'idle'"
      (click)="openFilePicker()"
      (dragenter)="onDragEnter($event)"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      [ngClass]="isDragging ? 'border-4 border-[#36bffa] bg-surface-bright' : 'border border-[#00BAE8]'"
      class="border-dashed rounded-[18px] py-16 px-8 flex flex-col items-center justify-center text-center w-full max-w-4xl min-h-[400px] transition-colors duration-200 cursor-pointer group">
      
      <!-- Upload Icon -->
      <img src="assets/upload-icon.png" alt="Upload Icon" class="w-16 h-16 mb-6 transition duration-200 group-hover:brightness-90" />

      <!-- Instructions Text -->
      <p class="text-[32px] leading-[40px] text-primary mb-6 text-center select-none">
        <span class="font-bold" id="File_Select">
          {{ 'Click to upload' | translate }}
        </span>
        <span class="font-light text-on-surface"> {{ 'or drag and drop' | translate }}</span>
      </p>

      <!-- Supported formats and limits -->
      <p class="text-sm text-on-surface-variant font-normal tracking-[0.25px] leading-5 text-center max-w-xl select-none">
        {{ 'WAV, MP3, M4A, WMV, CAF, OGG, OPUS: Max 500 MB / 3h; DSS, DS2: Max 250 MB / 3h' | translate }}
      </p>
    </div>

    <!-- State 2: Upload in Progress -->
    <div
      *ngIf="state === 'uploading'"
      class="flex flex-col items-center justify-center gap-6 text-center w-full max-w-4xl min-h-[400px]">

      <!-- Spinner (same as regenerate document) -->
      <img src="assets/spinner.svg" alt="" aria-hidden="true" class="spinner size-20" />

      <!-- Upload percentage -->
      <p class="headline-small text-primary select-none">
        {{ uploadProgress }}% {{ 'uploaded ...' | translate }}
      </p>

      <!-- Inline file name -->
      <p class="body-medium text-on-surface-variant max-w-2xl truncate select-none">
        {{ 'Uploading file...' | translate }} {{ displayFileName }}
      </p>

      <!-- Stay-on-page hint -->
      <p class="body-medium text-on-surface-variant max-w-md select-none">
        {{ 'Please remain on the page until the upload is complete' | translate }}
      </p>

      <!-- Cancel button -->
      <button
        mat-stroked-button
        id="Cancel_Upload"
        [attr.test-id]="'Cancel_Upload'"
        (click)="confirmCancelUpload()"
        class="cancel-btn">
        <mat-icon>cancel</mat-icon>
        {{ 'Cancel upload' | translate }}
      </button>
    </div>

    <!-- State 3: Processing -->
    <div
      *ngIf="state === 'processing'"
      class="flex flex-col items-center justify-center gap-6 text-center w-full max-w-4xl min-h-[400px]">

      <!-- Spinner (same as regenerate document) -->
      <img src="assets/spinner.svg" alt="" aria-hidden="true" class="spinner size-20" />

      <!-- Processing label -->
      <p class="headline-small text-primary select-none">
        {{ (processingTakingLong ? 'Still processing file...' : 'Processing file...') | translate }}
      </p>

      <!-- Inline file name -->
      <p class="body-medium text-on-surface-variant max-w-2xl truncate select-none">
        {{ 'Processing:' | translate }} {{ displayFileName }}
      </p>

      <!-- Stay-on-page hint -->
      <p class="body-medium text-on-surface-variant max-w-md select-none">
        {{ 'Please remain on the page until the upload and processing of your file is complete' | translate }}
      </p>

      <!-- Cancel button -->
      <button
        mat-stroked-button
        id="Cancel_Processing"
        [attr.test-id]="'Cancel_Processing'"
        (click)="confirmCancelProcessing()"
        class="cancel-btn">
        <mat-icon>cancel</mat-icon>
        {{ 'Cancel upload' | translate }}
      </button>
    </div>

    <!-- State 4: Complete -->
    <div
      *ngIf="state === 'complete'"
      class="flex flex-col items-center justify-center text-center w-full max-w-4xl min-h-[400px]">

      <!-- Success icon -->
      <div class="flex items-center justify-center size-24 rounded-full bg-primary-container mb-[38px]">
        <mat-icon svgIcon="check" class="text-on-surface-variant! size-10!"></mat-icon>
      </div>

      <!-- Status -->
      <h2 class="headline-small text-primary select-none">
        {{ 'Complete' | translate }}
      </h2>
    </div>

  </div>
</div>
